import React, { useEffect, useState } from 'react'
import { cerealesColor } from '../../../config/cereales'
import BarChart from './BarChart'
import { CircularProgress } from '@material-ui/core'

function BarChartFilasCalado (props) {
  const { estadoOcupacionCallesCalado, calificacionCalles, camionesCalados, w, h, x2 } = props
  const [data, setData] = useState([])

  useEffect(() => {
    const dataFilas = []

    const generarData = (estadoOcupacionCallesCalado) => {
      estadoOcupacionCallesCalado.filas.forEach((calle) => {
        dataFilas.push([
          `C${calle.calleDeCalado}`,
          calle.ocupado,
          (calle.cerealAsignado != null) ? cerealesColor[`${calle.cerealAsignado.trim()}`] : '#e0e0e0',
          `${calle.capacidad}`,
          `${calle.cerealAsignado}`,
          `Calle ${calle.calleDeCalado}-Capacidad ${calle.capacidad}-Usado ${calle.ocupado}-Cereal ${calle.cerealAsignado}`,
          calle.ordenDeSalida
        ])
      })
    }
    setData(dataFilas)

    if (estadoOcupacionCallesCalado !== null && estadoOcupacionCallesCalado.filas_procesadas > 0) {
      if (estadoOcupacionCallesCalado.estado === 'exito') {
        generarData(estadoOcupacionCallesCalado)
      }
    }
  }, [estadoOcupacionCallesCalado])

  return (
    <div className='container-barchart'>
      {(data.length > 0) && (calificacionCalles) && (camionesCalados) &&
      <BarChart
        width={w}
        height={h}
        data={data}
        calificacionCalles={calificacionCalles}
        camionesCalados={camionesCalados}
        xRange={[0, x2]}
        yRange={[400, 0]}
        setCalleDeCalado={props.setCalleDeCalado}
      />
      }
      {(data.length === 0) && <CircularProgress className='circular-progress' /> }
    </div>
  )
}

export default BarChartFilasCalado
